/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetApprovalRequestSettingsPathParams = NonNullable<
  operations['getApprovalRequestSettings']['parameters']['path']
>;

export type GetApprovalRequestSettingsQueryParams = NonNullable<
  operations['getApprovalRequestSettings']['parameters']['query']
>;

export interface Input extends GetApprovalRequestSettingsPathParams {
  apiVersion?: string;
  query?: GetApprovalRequestSettingsQueryParams;
  header: NonNullable<operations['getApprovalRequestSettings']['parameters']['header']>;
}

export async function getApprovalRequestSettings(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/approval-requests/projects/{projectKey}/settings', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
